import { createFileRoute, redirect } from "@tanstack/react-router";

/** Entry — sends the customer into the onboarding welcome screen. */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/welcome" });
  },
});
